import http from "../../http-common";
/* eslint-disable */
class StrukturOrganisasiService {
  strukturOrganisasiList(page, itemPerPage, keyword, dpd) {
    return http.get(
      "/struktur-organisasi/list?page=" +
        page +
        "&item_per_page=" +
        itemPerPage +
        "&keyword=" +
        keyword +
        "&dpd_id=" +
        dpd,
      {
        headers: {
          "Content-type": "application/json",
          Authorization:
            "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
        },
      },
    );
  }

  strukturOrganisasi(page, itemPerPage, keyword) {
    return http.get("/struktur-organisasi", {
      headers: {
        "Content-type": "application/json",
        Authorization:
          "Bearer " + localStorage.getItem(process.env.VUE_APP_TOKEN_PREFIX),
      },
    });
  }

  create(data) {
    var bodyFormData = new FormData();

    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.post("/struktur-organisasi", bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }

  update(data) {
    var bodyFormData = new FormData();
    bodyFormData.append("id", data.id);
    if (data.foto_url != null) bodyFormData.append("photo", data.foto_url);

    return http.put(`/struktur-organisasi/${data.id}`, bodyFormData, {
      headers: {
        "Content-Type": "multipart/form-data",
      },
    });
  }
}

export default new StrukturOrganisasiService();
